module.exports = __webpack_public_path__ + "img/shipment-active.458245c4.svg";